/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminProfileResponseDto,
  AdminProfileUpdateDto,
  ErrorResponse,
  GetPatientForProviderByIdResponseDto,
  PatientListResponseDto,
  PatientsPaginationRequestDto,
  PracticeListResponseDto,
} from '../models/index';
import {
    AdminProfileResponseDtoFromJSON,
    AdminProfileResponseDtoToJSON,
    AdminProfileUpdateDtoFromJSON,
    AdminProfileUpdateDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetPatientForProviderByIdResponseDtoFromJSON,
    GetPatientForProviderByIdResponseDtoToJSON,
    PatientListResponseDtoFromJSON,
    PatientListResponseDtoToJSON,
    PatientsPaginationRequestDtoFromJSON,
    PatientsPaginationRequestDtoToJSON,
    PracticeListResponseDtoFromJSON,
    PracticeListResponseDtoToJSON,
} from '../models/index';

export interface GetAllPatientsRequest {
    patientsPaginationRequestDto: PatientsPaginationRequestDto;
}

export interface GetAllPracticesRequest {
    pageSize: number;
    page?: number;
    nextPageToken?: string;
    search?: string;
    city?: string;
    sortBy?: GetAllPracticesSortByEnum;
    sortOrder?: GetAllPracticesSortOrderEnum;
}

export interface GetPatientDetailForAdminRequest {
    patientId: string;
}

export interface UpdateAdminProfileRequest {
    adminProfileUpdateDto: AdminProfileUpdateDto;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Get the current admin\'s profile information
     * Get admin profile
     */
    async getAdminProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProfileResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get the current admin\'s profile information
     * Get admin profile
     */
    async getAdminProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProfileResponseDto> {
        const response = await this.getAdminProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all patients across all practices with pagination, search, and filter options
     * Get all patients
     */
    async getAllPatientsRaw(requestParameters: GetAllPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientListResponseDto>> {
        if (requestParameters['patientsPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'patientsPaginationRequestDto',
                'Required parameter "patientsPaginationRequestDto" was null or undefined when calling getAllPatients().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/query/nextPageToken`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientsPaginationRequestDtoToJSON(requestParameters['patientsPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get all patients across all practices with pagination, search, and filter options
     * Get all patients
     */
    async getAllPatients(requestParameters: GetAllPatientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientListResponseDto> {
        const response = await this.getAllPatientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all practices with pagination, search, filter, and sort options for administrative purposes
     * Get all practices
     */
    async getAllPracticesRaw(requestParameters: GetAllPracticesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PracticeListResponseDto>> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getAllPractices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PracticeListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get all practices with pagination, search, filter, and sort options for administrative purposes
     * Get all practices
     */
    async getAllPractices(requestParameters: GetAllPracticesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PracticeListResponseDto> {
        const response = await this.getAllPracticesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve patient profile details and data-sharing context for administrators
     * Get patient details for admin
     */
    async getPatientDetailForAdminRaw(requestParameters: GetPatientDetailForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPatientForProviderByIdResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientDetailForAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPatientForProviderByIdResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve patient profile details and data-sharing context for administrators
     * Get patient details for admin
     */
    async getPatientDetailForAdmin(requestParameters: GetPatientDetailForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPatientForProviderByIdResponseDto> {
        const response = await this.getPatientDetailForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the current admin\'s profile information
     * Update admin profile
     */
    async updateAdminProfileRaw(requestParameters: UpdateAdminProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProfileResponseDto>> {
        if (requestParameters['adminProfileUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'adminProfileUpdateDto',
                'Required parameter "adminProfileUpdateDto" was null or undefined when calling updateAdminProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProfileUpdateDtoToJSON(requestParameters['adminProfileUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update the current admin\'s profile information
     * Update admin profile
     */
    async updateAdminProfile(requestParameters: UpdateAdminProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProfileResponseDto> {
        const response = await this.updateAdminProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAllPracticesSortByEnum = {
    Name: 'name',
    City: 'city'
} as const;
export type GetAllPracticesSortByEnum = typeof GetAllPracticesSortByEnum[keyof typeof GetAllPracticesSortByEnum];
/**
 * @export
 */
export const GetAllPracticesSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAllPracticesSortOrderEnum = typeof GetAllPracticesSortOrderEnum[keyof typeof GetAllPracticesSortOrderEnum];
